/**
 * @description variable plugin
 */
import { DomEditor, IDomEditor, SlateNode } from "@wangeditor/editor";
import { isString } from "lodash-es";
import emitter from "./mitt";

function getNumber(str: string) {
  const matches = str.match(/\d+(\.\d+)?/);
  const number = matches ? parseFloat(matches[0]) : 0;
  return number;
}

export function getLeftAndTop(editor: IDomEditor, node?: SlateNode) {
  const { width, height } = editor.getEditableContainer().getBoundingClientRect();
  const pos = node ? editor.getNodePosition(node) : editor.getSelectionPosition();
  const lineHeight = window.getComputedStyle(editor.getEditableContainer()).lineHeight;
  let __left: number = 0,
    __top: number = 0;
  if (isString(pos.left)) __left = getNumber(pos.left);
  if (isString(pos.top)) __top = getNumber(pos.top);
  if (isString(pos.bottom)) __top = height - getNumber(pos.bottom) + getNumber(lineHeight);
  if (isString(pos.right)) __left = width - getNumber(pos.right);
  // return node ? editor.getNodePosition(node) : editor.getSelectionPosition();
  return {
    left: __left,
    top: __top,
    isRight: !!pos.right
  };
}

function withVariable<T extends IDomEditor>(editor: T) {
  const { insertText, isInline, isVoid } = editor;
  const newEditor = editor;

  // 重写 insertText
  newEditor.insertText = (t) => {
    // 选过选中了 void 元素
    const elems = DomEditor.getSelectedElems(newEditor);
    const isSelectedVoidElem = elems.some((elem) => newEditor.isVoid(elem));
    if (isSelectedVoidElem) {
      insertText(t);
      return;
    }

    // variable 相关配置
    if (t === "$" || t === "￥") {
      setTimeout(() => {
        // 展示 modal （异步，以便准确获取光标位置）
        emitter.emit("show", getLeftAndTop(newEditor));

        // 监听，隐藏 modal（异步，等待 modal 渲染后再监听）
        setTimeout(() => {
          function _hide() {
            // if (hide) hide(newEditor);
            emitter.emit("hide", newEditor);
          }
          newEditor.once("fullScreen", _hide);
          newEditor.once("unFullScreen", _hide);
          newEditor.once("scroll", _hide);
          newEditor.once("modalOrPanelShow", _hide);
          newEditor.once("modalOrPanelHide", _hide);

          function hideOnChange() {
            if (newEditor.selection != null) {
              _hide();
              newEditor.off("change", hideOnChange); // 及时解绑
            }
          }
          newEditor.on("change", hideOnChange);
        });
      });
    }

    // 非 '@' 则执行默认行为
    insertText(t);
  };

  // 重写 isInline
  newEditor.isInline = (elem) => {
    const type = DomEditor.getNodeType(elem);
    if (type === "variable") {
      return true;
    }

    return isInline(elem);
  };

  // 重写 isVoid
  newEditor.isVoid = (elem) => {
    const type = DomEditor.getNodeType(elem);
    if (type === "variable") {
      return true;
    }

    return isVoid(elem);
  };

  return newEditor;
}

export default withVariable;
